import axios from 'axios';
import { ApiError } from '../../error';

// Card 74 — TipDirect Agent Summaries (weekly AI coaching info windows).
const url = '/api/v1/tipdirect/agent-summary';

export const fetchAgentSummary = () => {
  return axios
    .get(url)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const generateAgentSummary = () => {
  return axios
    .post(`${url}/generate`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const dismissAgentInsight = insightId => {
  return axios
    .post(`${url}/insights/${insightId}/dismiss`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};
